import { Order } from '~/@types/table/order';
import { apiClient } from '~/api/client';

type IndexParams = {
  json_params: string;
  id: string;
  sort_params: {
    field: string;
    order: Order;
  };
};

export const index = async ({ json_params, sort_params, id }: IndexParams) =>
  apiClient.get(
    `/realtors/${id}/team_members?json_params=${json_params}&sort[field]=${sort_params.field}&sort[order]=${sort_params.order}`
  );
